import React, { useState, useEffect } from 'react';

const Favicon = ({ url, name, favicon, className = "w-4 h-4" }) => {
  const [faviconError, setFaviconError] = useState(false);
  const [faviconUrl, setFaviconUrl] = useState('');
console.log(favicon,name,url);
  useEffect(() => {
    // Reset error state when props change
    setFaviconError(false);
    
    // First priority: Use favicon from API response
    if (favicon && favicon.trim() !== '') {
      setFaviconUrl(favicon);
      return;
    }

    // Second priority: Try to get favicon from URL
    if (!url) {
      setFaviconError(true);
      return;
    }

    // Try to get favicon from various sources
    const getFaviconUrl = (url) => {
      try {
        const domain = new URL(url).origin;
        return `${domain}/favicon.ico`;
      } catch (error) {
        return null;
      }
    };

    const generatedFavicon = getFaviconUrl(url);
    if (generatedFavicon) {
      setFaviconUrl(generatedFavicon);
    } else {
      setFaviconError(true);
    }
  }, [url, favicon]);

  const handleImageError = () => {
    setFaviconError(true);
  };
console.log(faviconError,faviconUrl);
  if (faviconError || !faviconUrl) {
    // Fallback to first letter of name
    const firstLetter = name ? name.charAt(0).toUpperCase() : '?';
    return (
      <div className={`${className} bg-zinc-700 rounded-sm flex items-center justify-center text-xs font-bold text-zinc-300`}>
        {firstLetter}
      </div>
    );
  }

  return (
    <img
      src={faviconUrl}
      alt={`${name} favicon`}
      className={`${className} rounded-sm`}
      onError={handleImageError}
      loading="lazy"
    />
  );
};

export default Favicon;
